import { DateTime } from "luxon";
import {
  BaseSupportContactResponse,
  BaseSupportContactRequest,
} from "@shared/types/common";

export default async (data?: object) => {
  const typedData = data as BaseSupportContactRequest;
  return {
    First_Name__c: typedData.first_name,
    Last_Name__c: typedData.last_name,
    Email__c: typedData.email,
    Time_zone: typedData.time_zone,
    Role_Type__c: typedData.role,
    CreatedDate: DateTime.now().toISO(),
    Status__c: "In Progress",
  } satisfies BaseSupportContactResponse;
};
